module.exports = __webpack_public_path__ + "img/img_def.5c25529c.png";